import { getUserFullName } from '@/helpers/getUserFullName'
import { ColleagueResource, ColleagueViewModel, DepartmentResource } from '@/models'
import { transformDepartmentResource } from '@/services/DepartmentService/transformDepartmentResource'

export function transformColleagueResource(
    colleague: ColleagueResource,
    departments: DepartmentResource[] = [],
): ColleagueViewModel {
    return {
        id: colleague.id,
        affix: colleague.affix,
        employeeNumber: colleague.employeeNumber,
        firstname: colleague.firstname,
        lastname: colleague.lastname,
        fullName: getUserFullName(colleague),
        departments: departments
            .map((department) => transformDepartmentResource(department)),
    }
}
